import { Component, OnInit, Input, EventEmitter, Output} from '@angular/core';
import { CommonUtilty, AppMetadataHandler,UserInfoService ,ApiRequestService,ComponentOutputDO,} from 'app';
import * as moment from 'moment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ApexNonAxisChartSeries, ApexAxisChartSeries, ApexChart, ApexPlotOptions, ApexTitleSubtitle, ApexFill, ApexStroke, ChartComponent, ApexDataLabels, ApexXAxis, ApexYAxis, ApexMarkers } from "ng-apexcharts";
import { environment } from 'environments/environment';
import { PersonalisedInobxService } from 'app/BaseFramework/core/services/personalized-inbox/personalised-inobx.service'
import { DataTransformService } from 'app/ViewModules/shared-services'; 

interface InboxAttributes {
  key: string,
  description: string,
  isVisible: boolean,
  pipe?: string,
  date?: boolean,
  formatter?: any;
  isSelected: boolean;
}

@Component({
  selector: 'app-personalized-view',
  templateUrl: './personalized-view.component.html',
  styleUrls: ['./personalized-view.component.scss']
})
export class PersonalizedViewComponent implements OnInit {

  _currentComponentName = 'PersonalizedViewComponent';

  constructor(private commonUtility: CommonUtilty,
    private appMetadataHandler: AppMetadataHandler,
    private message: NzMessageService,
    private userInfoService : UserInfoService,
    public apiRequestService: ApiRequestService,
    public commonUtilty: CommonUtilty,
    private personalisedInobxService : PersonalisedInobxService,
    public dataTransFormService : DataTransformService) {
  }

  @Input() configData = this.appMetadataHandler.configDataJSON;
  @Input() transactionState;
  @Input() smartUIConfig;
  extractedSmartUIConfig = {};
  @Output() componentOutput = new EventEmitter<any>();
  @Input() showPersonalizedConfigModal :boolean = false;
  @Input() privilegeCd;     // this is required when there is no menuDataList Input
  @Input()
  set IO(data) {
    if (data) {
      this.mapApiDataToFields(data);
    }
    else {
      this.personalisedInboxDetailsFetch();
    }
  }

  isAPIErrorResp = false;
  lookupsToBind = [];
  lookup$ = this.commonUtility.initializeLookupList(this.lookupsToBind)

  isAngularVersion8 : boolean = false;
  inboxDataPointsSuperSet: Array<InboxAttributes> = [];
  inboxDataPointsDefaultSet: Array<InboxAttributes> = [];
  
  APIErrorMsg = "Oops! Something went wrong on our end. Our team is already on it, and we'll have things back up and running smoothly as soon as possible. Thank you for your patience.";
  
  ngOnInit(): void {
    this.isAngularVersion8 = this.commonUtility.angularVersion() <= 8;
    // this.personalisedInboxDetailsFetch();
    this.dataTransFormService.enablePersonalizedInboxModal = true;
  }

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }
  /************Loader and its messages************/
  isLoadingFWAData = false;
  isLoadingFWAPattern: boolean = false;
  FWADataLoadingMsg = 'Processing Request. . .';
  pseudoLoad(t = 0) {
    this.isLoadingFWAData = true;
    let totalFakeLoadTime = t || 51250; //5125
    let divisions = 5;
    setTimeout(() => { this.FWADataLoadingMsg = "Initializing AI models . . ." }, ~~(totalFakeLoadTime / divisions) * 2);
    setTimeout(() => { this.FWADataLoadingMsg = "Computing fraud detection scores . . ." }, ~~(totalFakeLoadTime / divisions) * 4);
    setTimeout(() => { this.FWADataLoadingMsg = "Evaluating key metrics . . ." }, ~~(totalFakeLoadTime / divisions) * 6);
    setTimeout(() => { this.FWADataLoadingMsg = "Scanning for distinctive patterns . . ." }, ~~(totalFakeLoadTime / divisions) * 7);
    setTimeout(() => { this.FWADataLoadingMsg = "Executing a variety of algorithms on the dataset . . ." }, ~~(totalFakeLoadTime / divisions) * 8);
    setTimeout(() => { this.FWADataLoadingMsg = "Deriving specialized intelligence insights . . ." }, ~~(totalFakeLoadTime / divisions) * 9);
    // setTimeout(()=>{this.isLoadingFWAData=false},totalFakeLoadTime+650);
  }
  /************END: Loader and its messages************/


  personalisedInboxJson : any

inboxConfigModal : boolean = false
personalisedInboxDetailsFetch() {
  this.personalisedInobxService.fetchPersonalizedData(this.privilegeCd).subscribe((res : any)=>{
    if(res){
      if(res && res.menuDataList && this.commonUtilty.isArrayIterable(res.menuDataList) && res.menuDataList.length){
        this.mapApiDataToFields(res);
        this.dataTransFormService.enablePersonalizedInboxModal = true;
      }
    }
  },
  (error) => {
    this.isAPIErrorResp = true;
    this.APIErrorMsg = 'Unable to fetch personalized inbox details.';
  }
  )
}

mapApiDataToFields(data) {
  if(data && data.menuDataList && this.commonUtility.isArrayIterable(data.menuDataList) && data.menuDataList.length){
    this.personalisedInboxJson = data;
    this.inboxDataPointsDefaultSet= data.menuDataList.filter(item => item.isVisible);
    
    // Filter and push items to inboxDataPointsDefaultSet based on isVisible property
    this.inboxDataPointsSuperSet = data.menuDataList.filter(item => !item.isVisible);
  }
}

inboxCardFields = [
  {
    "key": "proposalNum",
    "description": "Proposal Number",
    "isVisible": true,
    "isSelected" : false,
    "searchFilter": true,
    "sortFilter": false,
    "pipe" : "",
    "ignoreTechnicalTranslate" : true
  },
  {
    "key": "statusCd",
    "description": "Proposal Status",
    "isVisible": true,
    "isSelected" : false,
    "searchFilter": false,
    "sortFilter": false,
    "pipe": 'technicalTranslate'
  },
  {
    "key": "policyCommencementDt",
    "description": "Policy Start Date",
    "date": true,
    "isVisible": true,
    "isSelected" : false,
    "searchFilter": true,
    "sortFilter": false,
    "pipe": 'date'
  },
  {
    "key": "policyExpiryDt",
    "description": "Policy Expiry Date",
    "date": true,
    "isVisible": true,
    "isSelected" : false,
    "searchFilter": true,
    "sortFilter": false,
    "pipe": 'date'
  },
  {
    "key": "baseProductCd",
    "description": "Product",
    "isVisible": true,
    "isSelected" : false,
    "searchFilter": true,
    "sortFilter": false,
    "pipe": 'technicalTranslate'
  },
  {
    "key": "sumInsured",
    "description": "Sum Assured",
    "formatter": true,
    "isVisible": true,
    "isSelected" : false,
    "searchFilter": true,
    "sortFilter": true,
    "pipe": 'CurrencyFormatter'
  },
  {
    "key": "stageCd",
    "description": "Workflow Stage",
    "isVisible": false,
    "isSelected" : false,
    "searchFilter": false,
    "sortFilter": false,
    "pipe": 'technicalTranslate'
  },
  {
    "key": "finalPremiumAmt",
    "description": "Premium",
    "formatter": true,
    "isVisible": true,
    "isSelected" : false,
    "searchFilter": true,
    "sortFilter": true,
    "pipe": 'CurrencyFormatter'
},
{
    "key": "premiumStatusCd",
    "description": "Premium Status",
    "isVisible": true,
    "isSelected" : false,
    "searchFilter": true,
    "sortFilter": false,
    "pipe": 'technicalTranslate'
  }
]

savepersonalisedInboxDetails() {
  this.personalisedInboxJson.menuDataList = [...this.inboxDataPointsDefaultSet,...this.inboxDataPointsSuperSet];
 this.personalisedInobxService.savePersonalizedDetails(this.personalisedInboxJson).subscribe((res : any)=>{
    if(res){
      if(res && res.menuDataList && this.commonUtilty.isArrayIterable(res.menuDataList) && res.menuDataList.length){
        this.EmitComponentOutput(res)
        this.dataTransFormService.enablePersonalizedInboxModal=false;
      }
    }
  },
  (error) => {
    this.APIErrorMsg = 'Unable to save personalized inbox details.';
  }
  )
}

formatApiResponse(menuDataList: any[]): any[] {
  return menuDataList.map((item) => {
    const formattedItem: any = {
      key: item.keyData,
      description: item.description,
      isVisible: item.isVisible,
      isSelected: item.isSelected,
      searchFilter: true, // Add your logic for searchFilter
      sortFilter: false, // Add your logic for sortFilter
      pipe: 'technicalTranslate', // Implement your logic to determine the pipe value
      ignoreTechnicalTranslate: true // Add your logic for ignoreTechnicalTranslate
    };

    if (item.date) {
      formattedItem.date = true;
    }

    if (item.formatter) {
      formattedItem.formatter = true;
    }

    return formattedItem;
  });
}


public removeItem(item: any, list: any[], action : string, index : number): void {
  list.splice(list.indexOf(item), 1);
  if(item && action == 'ADD'){
    this.inboxDataPointsDefaultSet.forEach(data =>{
      if(data.key == item.key) data.isVisible = true;
    })
  }
  if(item && action == 'DELETE'){
    this.inboxDataPointsSuperSet.forEach(data =>{
      if(data.key == item.key) data.isVisible = false;
    })
  }
  // this.setFilteredMetaDataMap();
}
selectAllAttributes() {
  this.inboxDataPointsDefaultSet = [...this.inboxDataPointsDefaultSet,...this.inboxDataPointsSuperSet];
  this.inboxDataPointsDefaultSet.forEach(field=>{
    field['isVisible'] = true;
  })
  // this.setFilteredMetaDataMap();
  this.inboxDataPointsSuperSet = [];
}
inboxDataSelected($event) {
  // this.setFilteredMetaDataMap();
}
}
